import { render } from "./CounselorDetailsReport.vue?vue&type=template&id=6e4dacb3&scoped=true"
import script from "./CounselorDetailsReport.vue?vue&type=script&lang=js"
export * from "./CounselorDetailsReport.vue?vue&type=script&lang=js"

import "./CounselorDetailsReport.vue?vue&type=style&index=0&id=6e4dacb3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4dacb3"]])

export default __exports__